import React, { Component } from 'react';
import { HeaderSub } from '../../Common/HeaderSub'
import { OrderMgrList } from './OrderMgrList';
import { OrderMgrDtl } from './OrderMgrDtl';
import { Big3Common } from '../../../js/IncludeManager'

/* 개발담당:양유빈
 * 화면기능: 구매내역 Index
 * 세부설명:
*/

export class Index extends Component {
    static displayName = Index.name;

    constructor(props) {
        super(props);
        this.state = {
            RenderName: this.CompName.OrderMgrList,  //기본 컴포넌트 할당
            ContentState: null
        };
        this.CsName = Big3Common.ContentState;
    }
    //호출할 컴포넌트 이름
    CompName = {
        "OrderMgrList": "OrderMgrList",
        "OrderMgrDtl": "OrderMgrDtl"
    }
    //초기화
    componentDidMount() {
        const Param_Alim_idx = Big3Common.Util.GetParams("alim_idx");       
        const Param_Ordgrp_No = Big3Common.Util.GetParams("ordgrp_no");       
        const Param_Uid = Big3Common.Util.GetParams("uid");
        if (Param_Ordgrp_No !== null && Param_Uid !== "" && (Param_Alim_idx === "07" || Param_Alim_idx === "15")) {
            //주문내역상세 이동
            const ContentState = {
                [this.CsName.Ordgrp_No]: Param_Ordgrp_No,
                [this.CsName.Uid]: Param_Uid
            }
            this.setState({
                ContentState: ContentState,
                RenderName: this.CompName.OrderMgrDtl
            });
        }
    }
    componentWillUnmount() {
        Big3Common.HistoryBackToClearBackdoor();
    }
    renderPick() {
        if (this.state.RenderName === this.CompName.OrderMgrList) {
            //주문내역 > 주문목록
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="주문내역"
                        HistoryBack={true}
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <OrderMgrList
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.OrderMgrDtl) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="주문내역상세"
                        ComponentUrl="OrderMgrList"
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                        ComponentName={this.state.RenderName}
                    />
                    <OrderMgrDtl
                        ContentState={this.state.ContentState}
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                    />

                </div>
            );
        }
        else {
            return (
                <div>
                    페이지가 없습니다
                </div>
            )
        }
    }
    render() {
        let RnderAct = this.renderPick();
        return (
            <div>
                {RnderAct}
            </div>
        );
    }
}
